import Select from "@/components/Select";
import React from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import Input from "@/components/Input";

export type DomainCondition = {
  domain: string;
  comparator: Comparator;
};

export function DomainEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const domainCondtion = JSON.parse(condition.data || "{}") as DomainCondition;

  function update(data: DomainCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  const validComparatorOptions: Record<string, string> = {
    equals: comparatorDefs.equals,
    notEquals: comparatorDefs.notEquals,
    contains: comparatorDefs.contains,
    notContains: comparatorDefs.notContains
  };

  return (
    <>
      <Select
        options={validComparatorOptions}
        value={domainCondtion.comparator}
        onChange={(v) => update({ ...domainCondtion, comparator: v })}
      />
      <Input
        className="w-full border rounded-md p-2"
        value={domainCondtion.domain}
        onChange={(v) => update({ ...domainCondtion, domain: v })}
      />
    </>
  );
}
